import r from"react";import{Box as t}from"theme-ui";var a=function(a){var e=a.children,i=a.variant,n=void 0===i?"primary":i,o=a.sx;return r.createElement(t,{variant:"card.".concat(n),sx:o},e)};export{a as Card};
//# sourceMappingURL=card.js.map
